/**
 * Created by stonewang on 2017/8/15.
 */
import React from 'react';
import Reflux from 'reflux';
import {brandStore,brandActions} from './store.js';
import { hashHistory,withRouter } from 'react-router';
import {Icon, Button, Menu, Dropdown,message} from 'antd';
import {DmsTab, TableView, FilterBox} from 'Components';
import {brandList,saveOrUpdate,brandDelete} from '../../service/productBrand';

class ProBrandList extends Reflux.Component {
	constructor(props) {
		super(props);
		this.store = Reflux.initStore(brandStore);
		this.state = {
			opts: ['产品品牌'],
			key: 0,
			filterBoxVisible: false,
			rows: [],
			selectedKeys:[],
			total: 0,
			searchObj: {
				name: '',
				code: '',
				active:null,
				p:1,
				s:10
			}
		};

		this.pageChange = this.pageChange.bind(this);
		this.visibleChange = this.visibleChange.bind(this);
		this.setFilterParam = this.setFilterParam.bind(this);
		this.advanceReset = this.advanceReset.bind(this);
		this.advanceSubmit = this.advanceSubmit.bind(this);
		this.dropdownClick = this.dropdownClick.bind(this);
		this.goView=this.goView.bind(this);
		this.getData=this.getData.bind(this);
		this.routeLeaveHook=this.routeLeaveHook.bind(this);
	}

	//离开当前路由时，更新store
	routeLeaveHook(nextLocation) {
		const {searchObj} =this.state;
		let path = nextLocation.pathname.split('/');
		let brandId=nextLocation.query.brandId;
		if(path[1] === 'productBrand' && path[2] === 'add'&&brandId){ //当下一个路由是详情页时，将useStore的值设为true
			brandActions.useStoreChange(true);
			brandActions.paramChange(searchObj);
		}else{
			brandActions.useStoreChange(false);
			brandActions.paramChange({});
		}
	}

	componentWillMount () {
		const data = this.store.state;
		if (data.useStore) { //根据useStore的值判断是否使用store中的数据
			this.setState({
				searchObj:data.storeData
			});
		}
	}

	componentDidMount(){
		this.getData();
		this.props.router.setRouteLeaveHook(this.props.route, this.routeLeaveHook);
	}

	//页面跳转
	goView (url) {
		hashHistory.push(url);
	}

	//获取数据
	getData(){
		var obj=this.state.searchObj;
		brandList(obj).then(result=>{
			if(result.status){
				var brandArr=result.data;
				this.setState({
					rows:brandArr,
					total:result.total
				})
			}else{
				message.error(result.message);
			}
		})
	}

	visibleChange() {
		this.setState({filterBoxVisible: !this.state.filterBoxVisible});
	}

	advanceReset() {
		const self = this;
		this.setState({
			filterBoxVisible: !this.state.filterBoxVisible,
			searchObj: {
				...this.state.searchObj,
				name: '',
				code: '',
				active:null,
				p: 1
			}
		}, () => {
			self.getData();
		});
	};

	advanceSubmit(form) {
		var submitObj=this.state.searchObj;
		submitObj.p=1;
		//有效性选择
		submitObj.active =submitObj.active|| null;

		const self = this;
		this.setState({
			filterBoxVisible: !this.state.filterBoxVisible,
			searchObj: submitObj}, function () {
			self.getData();
		});
	};

	setFilterParam(name, value) {
		this.setState({searchObj: {...this.state.searchObj, [name]: value}})
	};

	pageChange(page, pageSize) {
		const self = this;
		this.setState({ searchObj: { ...this.state.searchObj, s: pageSize, p: page } }, function () {
			self.getData();
		});
	}

	onVisibleChange(visible){
		this.setState({
			selectedKeys:[]
		});
	}

	dropdownClick({item, key, keyPath}) {
		const {selectedKeys} =this.state;
		selectedKeys.push(key);
		this.setState({
			selectedKeys
		});
		var arr = key.split('_');
		//编辑
		if (arr[0] === '0') {
			window.location.assign('#/productBrand/add?brandId=' + this.state.rows[arr[1]].id);
		}
		//失效
		if (arr[0] === '1') {
			var changeObj=this.state.rows[arr[1]];
			if(changeObj.active===0){
				changeObj.active=1;
			}else{
				changeObj.active=0;
			}
			saveOrUpdate(changeObj).then(result=>{
				if(result.status){
					message.success(result.message);
					this.getData();
				}else{
					message.error(result.message);
				}
			})
		};
		//删除
		if (arr[0] === '2') {
			var deleteObj={};
			deleteObj.id=this.state.rows[arr[1]].id;
			brandDelete(deleteObj).then(result=>{
				if(result.status){
					message.success(result.message);
					this.getData();
				}else{
					message.error(result.message);
				}
			})
		}
		;
	}

	menu(index) {
		return <Menu style={{width: "100px", textAlign: 'center'}}
					 onClick={this.dropdownClick}
					 selectedKeys={this.state.selectedKeys}>
			<Menu.Item key={`0_${index}`}>
				编辑
			</Menu.Item>
			<Menu.Item key={`1_${index}`}>
				{
					this.state.rows[index].active===1?
						'失效'
						:
						'有效'
				}
			</Menu.Item>
			<Menu.Item key={`2_${index}`}>
				删除
			</Menu.Item>
		</Menu>
	}

	render() {
		const {opts, filterBoxVisible, rows, total,searchObj} = this.state;
		const filterBoxProps = {
			showFlag: filterBoxVisible,
			advance: {
				fileds: [
					{
						name: 'name',
						label: '品牌名称',
						defaultValue:searchObj.name,
						text: '请输入品牌名称',
						type: 'default'
					},
					{
						name: 'code',
						label: '品牌编码',
						defaultValue:searchObj.code,
						text: '请输入品牌编码',
						type: 'default'
					},
					{
						name: 'active',
						label: '有效性',
						defaultValue:(searchObj.active!=null)?searchObj.active.toString():'',
						options: [
							{value: '1', text: '有效'},
							{value: '0', text: '无效'},
							{value: '', text: '全部'},
						],
						type: 'select'
					}
				],
				handle: this.advanceSubmit,
				reset: this.advanceReset,
				fieldHandle: this.setFilterParam
			}
		};
		const tableViewProps = {
			loading: false,//更新表格数据中
			rowKey: 'id',
			pageParam: {
				total,
				current: this.state.searchObj.p,//当前页码
				pageSize: this.state.searchObj.s,//当前分页数
				onChange: this.pageChange
			},
			columns: [{
				title: '名称',
				dataIndex: 'name',
				render: text => <span>{text}</span>,
			}, {
				title: '编码',
				dataIndex: 'code',
			}, {
				title: '排序',
				dataIndex: 'sortOrder',
			}, {
				title: '有效性',
				dataIndex: 'active',
				render: text => text === 1 ? <span style={{color: 'green'}}>有效</span> :
					<span style={{color: '#d61518'}}>无效</span>
			},
				{
					title: '更多操作',
					key: 'action',
          			className: 'alignCenter',
					render: (text, record, index) => (
						<Dropdown overlay={this.menu(index)}
								  placement='bottomCenter'
								  trigger={['click']}
								  onVisibleChange={this.onVisibleChange.bind(this)}>
							<span className="ant-dropdown-link">
								<Icon type="caret-down"/>
							</span>
						</Dropdown>
					)
				}],
			rows
		};
		return (
			<div className='dms-body'>
				<div>
					<DmsTab options={opts} defaultKey={0} onChange={this.changeHandle}>
						<Button icon="plus" onClick={this.goView.bind(this, '/productBrand/add')}>新增</Button>
						<Button icon="filter" onClick={this.visibleChange}>筛选</Button>
						<FilterBox  {...filterBoxProps}/>
					</DmsTab>
				</div>

				<div className="dms-table-box">
					<TableView {...tableViewProps} />
				</div>
			</div>
		)
	}
};
export default withRouter ( ProBrandList);



// WEBPACK FOOTER //
// ./src/routes/productBrand/list.js